import { useCallback, RefObject } from "react";
import { AgGridReact } from "ag-grid-react";
import useUiuxStore from "src/store/useUiuxStore";
import { SYS3010_R01Dto } from "../Dto_SYS3010_R01";

interface UseSYS3010_R01ModalProps {
	updateSYS3010_R01List: (index: number, data: SYS3010_R01Dto) => void;
	gridRef: RefObject<AgGridReact<SYS3010_R01Dto> | null>;
	compCdList: any[];
	orgCdList: any[];
}

export function useSYS3010_R01Modal({
	updateSYS3010_R01List,
	gridRef,
	compCdList,
	orgCdList,
}: UseSYS3010_R01ModalProps) {
	const { setCodeSearchModalProps } = useUiuxStore();

	const handlePopupClose = useCallback(() => {
		if (gridRef.current?.api) {
			gridRef.current.api.stopEditing();
		}
	}, [gridRef]);

	const settingCodeSearchModalProps = useCallback(
		(
			category: string,
			search: string,
			isInfo: boolean,
			handleFoucsId: string,
			originalData: SYS3010_R01Dto,
			valueIndex: number,
		) => {
			const wrapperOptionMap: Record<string, { size: string; width: number; overlay: boolean }> = {
				empNo: { size: "half", width: 20, overlay: true },
				autGroupCd: { size: "half", width: 20, overlay: true },
			};

			setCodeSearchModalProps({
				category,
				search,
				formName: "SYS3010_R01",
				isInfo,
				handleFoucsId,
				onClear: () => {
					if (handleFoucsId === "empNo") {
						updateSYS3010_R01List(valueIndex, {
							...originalData,
							empNo: "",
							empNm: "",
							compCd: "",
							compNm: "",
							orgCd: "",
							orgNm: "",
							isModified: originalData.inserted ? false : true,
						});
					}
					if (handleFoucsId === "autGroupCd") {
						updateSYS3010_R01List(valueIndex, {
							...originalData,
							autGroupCd: "",
							autGroupNm: "",
							isModified: originalData.inserted ? false : true,
						});
					}
					handlePopupClose();
				},
				onConfirm: (data: any) => {
					if (handleFoucsId === "empNo") {
						updateSYS3010_R01List(valueIndex, {
							...originalData,
							empNo: data.empNo ?? "",
							empNm: data.empNm ?? "",
							compCd: data.compCd ?? "",
							compNm: compCdList.find((value: any) => value.compCd === data.compCd)?.compNm || "",
							orgCd: data.orgCd ?? "",
							orgNm: orgCdList.find((value: any) => value.orgCd === data.orgCd)?.orgNm || "",
							isModified: originalData.inserted ? false : true,
						});
					}
					if (handleFoucsId === "autGroupCd") {
						updateSYS3010_R01List(valueIndex, {
							...originalData,
							autGroupCd: data.minorCd ?? "",
							autGroupNm: data.codeNm ?? "",
							isModified: originalData.inserted ? false : true,
						});
					}
				},
				wrapperOption: wrapperOptionMap[handleFoucsId] ?? { size: "half", width: 20, overlay: true },
			});
		}, [setCodeSearchModalProps, updateSYS3010_R01List, compCdList, orgCdList, handlePopupClose]);

	return { settingCodeSearchModalProps, handlePopupClose };
}
